module.exports = __webpack_public_path__ + "static/img/dou.f80a0162.png";